// [S101] Telemedicina Fase 1 — service da sala de vídeo (médico).
// Multi-tenant automático (o interceptor do api.js anexa o Bearer do JWT →
// companyId sai do token). Gated por clinic_config.telemedicina_enabled no backend.
import api from "./api";

// { enabled } — pro menu decidir se mostra "Teleconsulta".
export const getTeleconsultaConfig = async () =>
  (await api.get("/teleconsultas/config")).data;

// { sessions: [...] }
export const listTeleconsultas = async (params = {}) =>
  (await api.get("/teleconsultas", { params })).data;

// { session }
export const getTeleconsulta = async (id) =>
  (await api.get(`/teleconsultas/${id}`)).data;

// cria (ad-hoc: {patientName, patientPhone, professionalId?} OU {appointmentId})
// → { session, guestUrl, consent }
export const createTeleconsulta = async (payload) =>
  (await api.post("/teleconsultas", payload)).data;

// { iceServers } — STUN/TURN de curta duração pro RTCPeerConnection.
export const getTeleconsultaRtc = async (id) =>
  (await api.get(`/teleconsultas/${id}/rtc`)).data;

export const startTeleconsulta = async (id) =>
  (await api.post(`/teleconsultas/${id}/start`)).data;

export const endTeleconsulta = async (id, body = {}) =>
  (await api.post(`/teleconsultas/${id}/end`, body)).data;

export const cancelTeleconsulta = async (id) =>
  (await api.post(`/teleconsultas/${id}/cancel`)).data;
